import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {setHoveredSprite} from '../reducers/hovered-target';

import AssetSelectorItemComponent from '../components/asset-panel-ht/asset-selector-item.jsx';
import {updateAssetDrag} from '../reducers/asset-drag';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import {getEventXY} from '../lib/touch-utils';
import {getHomeworkInfo} from '../lib/homework-info';
import storage from '../lib/storage';
import getCostumeUrl from '../lib/get-costume-url';

const messages = defineMessages({
    deleteAlert: {
        defaultMessage: 'Are you sure you want to delete this?',
        description: 'delete sprite alert',
        id: 'gui.assetItem.deleteAlert'
    }
});

const dragThreshold = 3; // Same as the block drag threshold
let category;
let soundCategory;

class AssetSelectorItem extends React.Component {

    static getDerivedStateFromProps (props, state) {
        if (state.asset !== props.asset) {
            state.asset = props.asset;
            state.imgCommit = true;
        }
        return state;
    }

    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClick',
            'handleCopy',
            'handleDelete',
            'handlePlay',
            'handleEdit',
            'handleDisabled',
            'handleMouseEnter',
            'handleMouseLeave',
            'handleMouseDown',
            'handleMouseMove',
            'handleMouseUp',
            'getCostumeData'
        ]);
        this.state = {
            img: this.props.costumeURL,
            asset: this.props.asset,
            imgCommit: false
        };
    }

    componentDidMount () {
        this.homeworkInfo = getHomeworkInfo();
        this.courseId = Number(this.homeworkInfo.courseId);
        this.unitId = Number(this.homeworkInfo.unitId);
        this.lessonId = Number(this.homeworkInfo.lessonId);
        this.getImg();
    }

    componentDidUpdate () {
        if (this.state.imgCommit) {
            this.getImg();
            this.setState({
                imgCommit: false
            });
        }
    }

    getImg () {
        if (!this.props.asset) return;
        getCostumeUrl(this.props.asset).then(img => {
            this.setState({
                img
            });
        });
    }

    getCostumeData () {
        return this.state.img;
    }

    handleMouseUp () {
        this.initialOffset = null;
        window.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('touchend', this.handleMouseUp);
        window.removeEventListener('touchmove', this.handleMouseMove);
        this.props.onDrag({
            img: null,
            currentOffset: null,
            dragging: false,
            dragType: null,
            index: null
        });
        setTimeout(() => {
            this.noClick = false;
        });
    }
    handleMouseMove (e) {
        const currentOffset = getEventXY(e);
        const dx = currentOffset.x - this.initialOffset.x;
        const dy = currentOffset.y - this.initialOffset.y;
        if (Math.sqrt((dx * dx) + (dy * dy)) > dragThreshold) {
            this.props.onDrag({
                img: this. getCostumeData(),
                currentOffset: currentOffset,
                dragging: true,
                dragType: this.props.dragType,
                index: this.props.index,
                payload: this.props.dragPayload
            });
            this.noClick = true;
        }
        e.preventDefault();
    }
    handleMouseDown (e) {
        this.initialOffset = getEventXY(e);
        window.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('touchend', this.handleMouseUp);
        window.addEventListener('touchmove', this.handleMouseMove);
    }
    addFlag () {
        switch (this.props.assetType) {
        case 'backdrop':
            category = 'stage';
            soundCategory = 'stage';
            break;
        case 'costume':
            category = 'sprite';
            soundCategory = 'sprite';
            break;
        case 'sound':
            category = soundCategory || 'sprite';
            break;
        }
        return category;
    }
    getParam () {
        const category = this.addFlag(); //eslint-disable-line
        const type = this.props.assetType;
        const id = this.props.dragPayload.assetId;
        const name = this.props.name;
        let param;
        switch (type) {
        case 'backdrop':
            param = {stage: {id: id, name: name}};
            break;
        case 'costume':
            param = {sprite: {id: id, name: name}};
            break;
        case 'sound':
            param = {sprite: {id: id, name: name}};
            break;
        }
        return param;
    }
    handleSa (evtName) {
        const param = this.getParam();
        ht.track(evtName, {
            context: {
                courseId: this.courseId,
                unitId: this.unitId,
                lessonId: this.lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: param
        });
    }
    handleClick (e) {
        e.preventDefault();
        this.props.onClick(this.props.id);
        category = this.addFlag();
        this.handleSa(`s3_${category}_${this.props.assetType}_item_select`);
    }
    handleCopy (e) {
        if (this.handleDisabled()) {
            return;
        }
        e.preventDefault();
        if (this.props.onCopyButtonClick) {
            this.props.onCopyButtonClick(this.props.id);
        }
        category = this.addFlag();
        this.handleSa(`s3_${category}_${this.props.assetType}_item_copy`);
    }
    handleDelete (e) {
        if (this.handleDisabled()) {
            return;
        }
        e.stopPropagation(); // To prevent from bubbling back to handleClick
        const msg = this.props.intl.formatMessage(messages.deleteAlert);
        // eslint-disable-next-line no-alert
        if (window.confirm(msg)) {
            this.props.onDeleteButtonClick(this.props.id);
            category = this.addFlag();
            this.handleSa(`s3_${category}_${this.props.assetType}_item_remove`);
        }
    }
    handlePlay (e) {
        e.preventDefault();
        if (this.props.onPlayClick) {
            this.props.onPlayClick(this.props.id);
            category = this.addFlag();
            this.handleSa(`s3_${category}_${this.props.assetType}_item_play`);
        }
    }
    handleEdit (e) {
        if (this.handleDisabled()) {
            return;
        }
        e.preventDefault();
        if (this.props.onEditButtonClick) {
            this.props.onEditButtonClick(this.props.id);
            category = this.addFlag();
            this.handleSa(`s3_${category}_${this.props.assetType}_item_edit`);
        }
    }
    handleMouseLeave () {
        this.props.dispatchSetHoveredSprite(null);
    }
    handleMouseEnter () {
        this.props.dispatchSetHoveredSprite(this.props.id);
    }
    handleDisabled () {
        if (this.props.disabled) {
            alert('不要改动老师已经写好的角色，会影响你正常过关'); // eslint-disable-line
            return true;
        }
        return false;
    }

    render () {
        const {
            /* eslint-disable no-unused-vars */
            assetType,
            dragPayload,
            index,
            isPlaying,
            name,
            number,
            onChangeName,
            onStopClick,
            selected
            /* eslint-enable no-unused-vars */
        } = this.props;
        return (
            <AssetSelectorItemComponent
                assetType={assetType}
                costumeURL={this.getCostumeData()}
                isPlaying={isPlaying}
                name={name}
                number={number}
                selected={selected}
                onChangeName={onChangeName}
                onCopyButtonClick={this.handleCopy}
                onDeleteButtonClick={this.props.onDeleteButtonClick ? this.handleDelete : null}
                onEditButtonClick={this.handleEdit}
                onItemClick={this.handleClick}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onPlayButtonClick={this.handlePlay}
                onStopButtonClick={onStopClick}
            />
        );
    }
}

AssetSelectorItem.propTypes = {
    asset: PropTypes.instanceOf(storage.Asset),
    assetType: PropTypes.string,
    costumeURL: PropTypes.string,
    disabled: PropTypes.bool,
    dispatchSetHoveredSprite: PropTypes.func.isRequired,
    dragPayload: PropTypes.shape({
        assetId: PropTypes.number,
        name: PropTypes.string,
        body: PropTypes.string
    }),
    dragType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    index: PropTypes.number,
    intl: intlShape.isRequired,
    isPlaying: PropTypes.bool,
    name: PropTypes.string,
    number: PropTypes.number,
    onChangeName: PropTypes.func,
    onClick: PropTypes.func,
    onCopyButtonClick: PropTypes.func,
    onDeleteButtonClick: PropTypes.func,
    onDrag: PropTypes.func.isRequired,
    onEditButtonClick: PropTypes.func,
    onPlayClick: PropTypes.func,
    onStopClick: PropTypes.func,
    selected: PropTypes.bool
};

const mapStateToProps = () => ({
    // costumeURL: costumeURL || (assetId && state.scratchGui.vm.runtime.storage.get(assetId).encodeDataURI())
});
const mapDispatchToProps = dispatch => ({
    dispatchSetHoveredSprite: spriteId => {
        dispatch(setHoveredSprite(spriteId));
    },
    onDrag: data => dispatch(updateAssetDrag(data))
});

const AssetSelectorItemIntl = injectIntl(AssetSelectorItem);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetSelectorItemIntl);
